module.exports = __webpack_public_path__ + "static/media/bleedtestline.8e0b7c22.png";